import type { Directive } from 'vue'
import { usePermissionStore } from '@/stores/permission'

function apply(el: HTMLElement, code: string | undefined) {
  const store = usePermissionStore()
  const c = typeof code === 'string' ? code.trim() : ''
  if (!c) {
    el.style.display = ''
    return
  }
  el.style.display = store.hasPerm(c) ? '' : 'none'
}

type PermCtx = { code: string | undefined }

/** 仅 ASCII 权限码，如 v-perm="'pf:emergency:case:add'"；随权限 Store 与绑定值变化更新 */
export const vPerm: Directive<HTMLElement, string | undefined> = {
  mounted(el, binding) {
    const store = usePermissionStore()
    const ctx: PermCtx = { code: binding.value }
    const run = () => apply(el, ctx.code)
    run()
    const unsub = store.$subscribe(run)
    ;(el as unknown as { __permCtx: PermCtx; __permUnsub: () => void }).__permCtx = ctx
    ;(el as unknown as { __permCtx: PermCtx; __permUnsub: () => void }).__permUnsub = unsub
  },
  updated(el, binding) {
    const wrap = el as unknown as { __permCtx?: PermCtx }
    if (wrap.__permCtx) wrap.__permCtx.code = binding.value
    apply(el, binding.value)
  },
  unmounted(el) {
    ;(el as unknown as { __permUnsub?: () => void }).__permUnsub?.()
  },
}
